import { usePageId } from '@marketplace-web/environment/request-context-data'
import { SearchBarSearchType } from '@marketplace-web/search/search-feature'

export function useHeaderSearchType(): SearchBarSearchType {
  const pageId = usePageId()

  if (pageId?.startsWith('member')) return SearchBarSearchType.User

  return SearchBarSearchType.Item
}
